/* global window */

import React from 'react';
import classnames from 'classnames';
import { trackNow } from 'shared/models/analytic';
import { Small } from 'scy/text';
import { InputGroup } from 'scy/Input';
import styles from './styles.mod.scss';
import margin from 'scy/margin.mod.scss';

class TextToDownload extends React.Component {
  constructor(props) {
    super(props);
    this.sms = this.sms.bind(this);
  }

  sms(event) {
    event.preventDefault();
    var phone = this.phoneInput.value;
    var linkData = {
      channel: 'Website',
      feature: 'TextMeTheApp'
    };
    if (window.branch) {
      window.branch.sendSMS(phone, linkData, {}, function(error) {
        console.log(error); // eslint-disable-line no-console
      });
    }
    trackNow('Text Me the App', {
      path: window.location.pathname,
      section: this.props.section
    });
    this.phoneInput.value = '';
  }

  render() {
    return (
      <div
        className={classnames(
          styles.container,
          { [styles.wide]: this.props.wide },
          this.props.className
        )}
      >
        <Small tag="div" marginClass={margin.bottom_sm}>
          Enter your number &amp; we’ll text you a download link
        </Small>
        <InputGroup
          onSubmit={this.sms}
          className={margin.bottom_sm}
          prefix="+1"
          inputProps={{
            id: 'phone-input',
            name: 'phone',
            type: 'tel',
            ref: input => (this.phoneInput = input),
            placeholder: '(123) 456-7890'
          }}
          buttonText="Send"
        />
      </div>
    );
  }
}

export default TextToDownload;
